// actions/types/kitchenActionTypes.js
export const FETCH_KITCHEN_ORDERS_REQUEST = "FETCH_KITCHEN_ORDERS_REQUEST";
export const FETCH_KITCHEN_ORDERS_SUCCESS = "FETCH_KITCHEN_ORDERS_SUCCESS";
export const FETCH_KITCHEN_ORDERS_FAILURE = "FETCH_KITCHEN_ORDERS_FAILURE";